module.exports = __webpack_public_path__ + "img/bg_1.4d818b40.jpg";